import { Link } from "react-router-dom";
import "./FrameModelLinks.css";

const FRAME_MODELS = [
  {
    id: "individuales",
    name: "Marcos individuales",
    to: "/marcos-individuales",
    image:
      "/images/frame-gallery/frame-gallery-individuales/frame-gallery-individuales-escritorio.webp",
  },
  {
    id: "duo",
    name: "Marco Duo",
    to: "/marco-duo",
    image:
      "/images/frame-gallery/frame-gallery-duo/frame-gallery-duo-comedor.webp",
  },
  {
    id: "mosaico",
    name: "Marco Mosaico",
    to: "/marco-mosaico",
    image:
      "/images/frame-gallery/frame-gallery-mosaico/frame-gallery-mosaico-estanteria.webp",
  },
  {
    id: "secuencia",
    name: "Marco Secuencia",
    to: "/marco-secuencia",
    image:
      "/images/frame-gallery/frame-gallery-secuencia/frame-gallery-secuencia-salon.webp",
  },
];

export default function FrameModelLinks({ currentModel }) {
  const availableModels = FRAME_MODELS.filter(
    (model) => model.id !== currentModel
  );

  return (
    <section className="frame-model-links" aria-labelledby="frame-model-links-title">
      <div className="frame-model-links__heading">
        <h2 id="frame-model-links-title">Prueba otros modelos de marcos</h2>
        <p>Elige otra forma de reunir tus recuerdos.</p>
      </div>

      <div className="frame-model-links__track">
        {availableModels.map((model) => (
          <Link key={model.id} to={model.to} className="frame-model-links__item">
            <img src={model.image} alt="" loading="lazy" decoding="async" />
            <span>{model.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
